import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { translationEN } from "../config/translationEN";
import { translationNL } from "../config/translationNL";
import { translationDE } from "../config/translationDE";
import { translationDK } from "../config/translationDK";
import { translationES } from "../config/translationES";
import { translationFR } from "../config/translationFR";
import { translationIS } from "../config/translationIS";
import { translationIT } from "../config/translationIT";

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      de: translationDE,
      da: translationDK,
      en: translationEN,
      es: translationES,
      fr: translationFR,
      is: translationIS,
      it: translationIT,
      nl: translationNL,
    },
    // lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
